import { type LucideIcon } from "lucide-react"
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/modules/shared/ui/components/tooltip"

interface TooltipWrapProps {
  title: string
  description: string
  icon?: LucideIcon
  side?: "top" | "bottom" | "left" | "right"
  children: React.ReactNode
}

export function TooltipWrap({
  title,
  description,
  icon: Icon,
  side = "top",
  children,
}: TooltipWrapProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side={side} className="max-w-[260px] p-0 overflow-hidden">
        <div className="px-3.5 py-2.5 space-y-1">
          <div className="flex items-center gap-2">
            {Icon && <Icon className="w-3.5 h-3.5 shrink-0 text-primary" />}
            <span className="text-[13px] font-semibold text-white leading-tight">
              {title}
            </span>
          </div>
          <p className="text-[11px] leading-relaxed text-white">
            {description}
          </p>
        </div>
      </TooltipContent>
    </Tooltip>
  )
}
